import React from 'react';
import logo from "../../assets/images/logo.png";

function ModernLogo() {
    const handleLogoClick = () => {
        const idLoja = sessionStorage.getItem('loja');
        window.location.href = idLoja ? `/?id=${idLoja}` : '/';
    };

    return (
        <div
            className="modern-logo-wrapper"
            onClick={handleLogoClick}
            style={{ cursor: 'pointer' }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleLogoClick();
                }
            }}
            aria-label="Ir para a página inicial"
        >
            <div className="modern-logo-capsule">
                <img
                    alt="Logo da empresa"
                    src={logo}
                    className="modern-logo-img p-1"
                />
            </div>
        </div>
    );
}

export default ModernLogo;
